import { ClientConfig } from '../config/ClientConfig'
import { HttpService } from './http-service'
import { LeaderboardDTO } from '../communication/OperatorPublicApi'
import { HistoricHand } from '../communication/PlayerApiProtocol.generated'

type LeaderboardPositionResponse = {
	userId: number;
	screenName: string;
	points: number;
	position: number;
}

export function isLeaderboardPositionResponse(obj: any): obj is LeaderboardPositionResponse {
	return obj.userId !== undefined
}

type NoLeaderboardPositionResponse = {
}

type LeaderboardConfigResponse = {
	id: string;
	name: string;
	description: string;
	periodStart: Date;
	periodEnd: Date;
}

type LeaderboardResponse = {
	leaderboard: LeaderboardConfigResponse,
	entries: LeaderboardPositionResponse[]
}

export const LeaderboardsApiService = new (class {
	private baseUrl = ClientConfig.GAMIFICATION_URL

	async getGameClientLeaderboards() {
		const gamificationUrl = `${this.baseUrl}/leaderboards?source=GameClient`

		return HttpService
			.get<LeaderboardDTO[]>(gamificationUrl, { authenticate: true })
	}

	async getMyLeaderboardPosition(leaderboardId: String, userId: number) {
		const gamificationUrl = `${this.baseUrl}/leaderboards/${leaderboardId}/${userId}`

		return HttpService
			.get<LeaderboardPositionResponse | NoLeaderboardPositionResponse>(gamificationUrl, { authenticate: true })
	}

	async getLeaderboardPositions(leaderboardId: String) {
		const gamificationUrl = `${this.baseUrl}/leaderboards/${leaderboardId}`

		return HttpService
			.get<LeaderboardResponse>(gamificationUrl, { authenticate: true })
	}

	async getLeaderboardEntryHand(entryId: String): Promise<HistoricHand> {
		const gamificationUrl = `${this.baseUrl}/leaderboards/v3/entries/${entryId}/hand`
		return HttpService.get<HistoricHandResponse>(gamificationUrl)
			.then((res) => res.hand)
	}
})()

interface HistoricHandResponse {
	hand: HistoricHand,
	nextHandId: string,
	prevHandId: string,
}
